import React from 'react';
import { MailIcon, CreditCardIcon, DownloadIcon } from 'lucide-react';
export function HowItWorks() {
  return <section className="bg-white py-2 px-4" data-id="element-214">
      <div className="max-w-3xl mx-auto" data-id="element-215">
        <h2 className="text-lg md:text-xl font-bold text-gray-900 mb-2 text-center" data-id="element-216">
          🔽 ¿Cómo recibís el material?
        </h2>

        <div className="flex flex-col md:flex-row items-stretch md:items-center justify-center gap-1 md:gap-4 text-center" data-id="element-217">
          <div className="flex items-center gap-2 justify-center py-1" data-id="element-218">
            <div className="w-7 h-7 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 flex-shrink-0" data-id="element-219">
              <MailIcon className="w-3.5 h-3.5" data-id="element-220" />
            </div>
            <p className="text-gray-700 text-sm" data-id="element-221">
              <span className="font-bold" data-id="element-222">1.</span> Comprás e ingresás tu correo
            </p>
          </div>
          <span className="hidden md:block text-gray-300" data-id="element-223">→</span>
          <div className="flex items-center gap-2 justify-center py-1" data-id="element-224">
            <div className="w-7 h-7 bg-green-100 rounded-full flex items-center justify-center text-green-600 flex-shrink-0" data-id="element-225">
              <CreditCardIcon className="w-3.5 h-3.5" data-id="element-226" />
            </div>
            <p className="text-gray-700 text-sm" data-id="element-227">
              <span className="font-bold" data-id="element-228">2.</span> Pagás de forma segura
            </p>
          </div>
          <span className="hidden md:block text-gray-300" data-id="element-229">→</span>
          <div className="flex items-center gap-2 justify-center py-1" data-id="element-230">
            <div className="w-7 h-7 bg-purple-100 rounded-full flex items-center justify-center text-purple-600 flex-shrink-0" data-id="element-231">
              <DownloadIcon className="w-3.5 h-3.5" data-id="element-232" />
            </div>
            <p className="text-gray-700 text-sm" data-id="element-233">
              <span className="font-bold" data-id="element-234">3.</span> Recibís el link de descarga
            </p>
          </div>
        </div>

        <p className="mt-1.5 text-xs text-gray-500 text-center" data-id="element-235">
          ⚠️ Si no lo ves en tu bandeja principal, revisá spam.
        </p>
      </div>
    </section>;
}